import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SessionProvider } from "@/lib/session";
import { Toaster } from "sonner";
import RoleSwitcher from "@/pages/RoleSwitcher";
import StudentPicker from "@/pages/StudentPicker";
import StudentDashboard from "@/pages/StudentDashboard";
import TracingExercise from "@/pages/TracingExercise";
import StudentProfile from "@/pages/StudentProfile";
import TherapistDashboard from "@/pages/TherapistDashboard";
import TherapistStudent from "@/pages/TherapistStudent";
import ParentDashboard from "@/pages/ParentDashboard";

function App() {
  return (
    <div className="App">
      <SessionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleSwitcher />} />
            <Route path="/student" element={<StudentPicker />} />
            <Route path="/student/:id" element={<StudentDashboard />} />
            <Route path="/student/:id/profile" element={<StudentProfile />} />
            <Route path="/student/:id/exercise/:exerciseId" element={<TracingExercise />} />
            <Route path="/therapist" element={<TherapistDashboard />} />
            <Route path="/therapist/student/:id" element={<TherapistStudent />} />
            <Route path="/parent" element={<ParentDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SessionProvider>
    </div>
  );
}

export default App;
